import { render } from "./Hbody.vue?vue&type=template&id=4445f135&scoped=true"
import script from "./Hbody.vue?vue&type=script&lang=js"
export * from "./Hbody.vue?vue&type=script&lang=js"

import "./Hbody.vue?vue&type=style&index=0&id=4445f135&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4445f135"]])

export default __exports__